<style lang="less"> 
</style>

<template>
  <div>
    <input ref="input1" v-bind:value="value" type="hidden">
    <el-select v-model="value1" placeholder="请选择">
      <el-option :value="1" >
        <div class="ws-selectTree">
          <el-tree :data="treeData" :props="props" @node-click="handleNodeClick" node-key="id" ref="tree" highlight-current></el-tree>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    props: {
      value: {
        required: true
      },
      treeData: {
        type: Array,
        default: function() {
          return [];
        }
      },
      props: {
        type: Object,
        default: function() {
          return {
            children: 'children',
            label: 'label'
          }
        }
      }
    },
    data() {
      return {
        value1: ''
      }
    },
    watch: {
      value1(val) {
        // this.$emit('input', val);
      }
    },
    mounted() {
      this.$nextTick(function() {
        $('.ws-selectTree').parent().css('padding', '0px').css('height', '100%');
        $('.ws-selectTree').parent().parent().css('padding', '0px');
      });
    },
    methods: {
      handleNodeClick(data) {
        this.$emit('input', data.key);
        let params = {
          value: data.label
        };
        var parent = this.$refs['tree'].$parent.$parent.$parent.$parent || this.$root;
        if (parent) {
          parent.$emit.apply(parent, ['handleOptionClick'].concat(params));
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// index.vue?5c3a361c